<template>
  <div class="overflow-x justify-content-center mt-5">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th >نام جام</th>
                <th >تاریخ آغاز</th>
                <th >هزینه ورودی تیم</th>
                <th >حوزه ورزشی</th>
                <th >گروه سنی</th>
                <th >وضعیت</th>
                <th>استان/شهر</th>
                <th >جنسیت</th>
                <th ></th>

              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">
                <td>{{data.title}} </td>
                <th >{{data.fixedAtDateJlali}}</th>
                <td>{{data.addCamaAmount}}+</td>
                <td>
                  <div>
                    {{allEnums.using_type[data.using_type] }}
                  </div>
                </td>
                <td>
                  <div>
                    {{allEnums.age_group[data.age_group] }}
                  </div>
                </td>
                <td>{{data.nameStatus}}</td>
                <td>{{data.province_city_text}}</td>
                <td>
                  <div>
                    {{allEnums.gender[data.gender] }}
                  </div>
                </td>

                <td>
                    <div class="d-flex justify-content-end flex-column">
                            <div class="row w-100 justify-content-center flex-column align-items-center">
                              <button @click="descriptionCup(data)" type="button" class="btn btn-primary btn-blue btn-sm btn-table mb-3">
                                توضیحات جام
                              </button>
                              <button @click="editCup(data)" type="button" class="btn btn-primary btn-blue btn-sm btn-table mb-3">
                                ویرایش
                              </button>
                              <button @click="goPageGameFuture(data)" type="button" class="btn btn-primary btn-blue btn-sm btn-table ">
                                بازی های آینده
                              </button>
                            </div>
                    </div>
                </td>

              </tr>


            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="20" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>


export default {
    name: 'tableContent',
    props: {
      tableData     : { type: [Array, Object], default: [] },
      page          : { type: Number, default: 0 },
      allEnums      : { type: [Array, Object], default: {} },
    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },

      allEnums(data){
        console.log(data);
      }

    },

    methods: {
      changePage(page){
        this.$emit('paganationChangePage',page)
      },

      descriptionCup(data){
        this.$emit('descriptionCup',data)
      },

      editCup(data){
        localStorage.setItem("singleCupData", JSON.stringify(data));
        this.$router.push({name:'entryAndEditListCup', params:{id:data.id}} )
      },

      goPageGameFuture(data){
        this.$router.push({name:'gameFuture', params:{cup_id:data.id,state_match_check_future_passed:'future'}} )
      },


    },

}
</script>
